import React from 'react';
import { Avatar, Badge, Card } from 'antd';
import { CrownOutlined, UserOutlined } from '@ant-design/icons';
import './LeaderboardCard.css';

interface User {
  id: string | number;
  name: string;
  calls: number;
  avatar?: string | null;
}

interface LeaderboardCardProps {
  users: User[];
  comingSoon?: boolean;
}

const LeaderboardCard: React.FC<LeaderboardCardProps> = ({ users, comingSoon }) => {
  return (
    <Card className={`leaderboard-card ${comingSoon ? 'leaderboard-card--coming-soon' : ''}`}>
      <div className="leaderboard-card__header">
        <div className="leaderboard-card__icon-wrapper">
          <CrownOutlined style={{ fontSize: 24, color: '#10b981' }} />
        </div>
        <span className="leaderboard-card__title">PLUS ACTIFS CETTE SEMAINE</span>
        {comingSoon && <Badge count="Soon" className="soon-badge" />}
      </div>
      <div className="leaderboard-card__list">
        {users.map((user, index) => (
          <div key={user.id} className="leaderboard-card__item">
            <Avatar
              size={44}
              src={user.avatar}
              icon={!user.avatar && <UserOutlined />}
              className="leaderboard-card__avatar"
            />
            <div className="leaderboard-card__info">
              <span className="leaderboard-card__name">{user.name}</span>
              <span className="leaderboard-card__calls">{user.calls} appels</span>
            </div>
            <span className={`leaderboard-card__rank leaderboard-card__rank--${index + 1}`}>
              #{index + 1}
            </span>
          </div>
        ))}
      </div>
    </Card>
  );
};

export default LeaderboardCard;
